<af-header></af-header>
<af-banner></af-banner>
<af-toolbar></af-toolbar>
<router-outlet></router-outlet>
<af-footer></af-footer>
